import React from 'react';
import { motion } from 'framer-motion';

const ImpactSection = ({ content }) => {
    const impact = content?.find(c => c.section_name === 'impact');
    if (!impact) return null;

    return (
        <section className="py-20 md:py-32 bg-white overflow-hidden">
            <div className="container mx-auto px-6">
                <div className="flex flex-col md:flex-row items-center gap-16">

                    {/* Image Side */}
                    <div className="w-full md:w-1/2">
                        <motion.div
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            viewport={{ once: true }}
                            transition={{ duration: 0.8 }}
                            className="relative rounded-[2.5rem] overflow-hidden aspect-[4/3]"
                        >
                            <img
                                src="/images/sr-agro-6.jpeg"
                                alt="Farming Impact"
                                className="w-full h-full object-cover"
                            />
                            {/* Floating Card */}
                            <div className="absolute bottom-8 right-8 bg-white p-6 rounded-2xl shadow-xl max-w-xs hidden md:block">
                                <p className="text-agro-green font-bold text-4xl font-serif mb-1">100+</p>
                                <p className="text-gray-500 font-sans text-sm">Active Villages across Karnataka</p>
                            </div>
                        </motion.div>
                    </div>

                    {/* Content Side */}
                    <div className="w-full md:w-1/2">
                        <div className="max-w-xl">
                            <p className="text-agro-lime font-sans uppercase tracking-widest text-sm mb-4 font-semibold">
                                Our Impact
                            </p>
                            <h2 className="text-4xl md:text-5xl font-serif text-agro-black leading-tight mb-8">
                                {impact.title}
                            </h2>

                            <div className="text-gray-600 font-sans text-lg leading-relaxed space-y-6">
                                {impact.content.split('\n').map((line, i) => (
                                    <p key={i} className="flex items-start">
                                        {line.trim().startsWith('•') ? (
                                            <>
                                                <span className="w-2 h-2 bg-agro-green rounded-full mr-4 mt-2.5 flex-shrink-0" />
                                                <span>{line.replace('•', '').trim()}</span>
                                            </>
                                        ) : line}
                                    </p>
                                ))}
                            </div>

                            <div className="mt-10 pt-10 border-t border-gray-100 grid grid-cols-2 gap-8">
                                <div>
                                    <h4 className="text-3xl font-serif text-agro-black mb-1">500+</h4>
                                    <p className="text-gray-500 text-sm">Partner Farmers</p>
                                </div>
                                <div>
                                    <h4 className="text-3xl font-serif text-agro-black mb-1">100%</h4>
                                    <p className="text-gray-500 text-sm">Ethical Practices</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default ImpactSection;
